import { DynamicPageBaseComponentModel } from "./dynamicPageBaseComponentModel"

export class DynamicPageTextBlockModel extends DynamicPageBaseComponentModel {
  constructor(c = {}) {
    super(c, "TextBlock")
    this.text = c.text
    this.image_resources = c.image_resources || []
  }
}
